import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { cn } from '@/lib/utils'
import FriendListTab from '@/components/feature/friends/FriendListTab'
import RankingTab from '@/components/feature/friends/RankingTab'

type Tab = 'ranking' | 'list'

export default function FriendsPage() {
  const [searchParams, setSearchParams] = useSearchParams()
  // 通知（フレンド申請）から /friends?requests=1 で来たら一覧タブ＋申請シートを開く。
  // 初期表示に反映したいので state の初期値に織り込み、effect は URL の掃除だけを行う。
  const fromRequest = searchParams.get('requests') === '1'
  // 戻る操作で /friends?tab=list が復元された場合にタブを再現する。
  const initialTab: Tab = fromRequest ? 'list' : searchParams.get('tab') === 'list' ? 'list' : 'ranking'
  const [activeTab, setActiveTab] = useState<Tab>(initialTab)
  const [requestsOpen, setRequestsOpen] = useState(fromRequest)

  useEffect(() => {
    if (searchParams.get('requests') === '1') {
      // すでに /friends に居る場合は再マウントされず初期 state が効かないため、
      // ここで一覧タブ＋申請シートを明示的に開く（どのページからでも遷移できるように）。
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setActiveTab('list')
      setRequestsOpen(true)
      // 申請経由は requests を消し、戻る用に tab=list を URL へ残す。
      const next = new URLSearchParams(searchParams)
      next.delete('requests')
      next.set('tab', 'list')
      setSearchParams(next, { replace: true })
    }
  }, [searchParams, setSearchParams])

  // タブ切替を URL に反映しておくと、検索画面から戻ったときに選択状態が復元される。
  const selectTab = (tab: Tab) => {
    setActiveTab(tab)
    const next = new URLSearchParams(searchParams)
    next.set('tab', tab)
    setSearchParams(next, { replace: true })
  }

  return (
    <div className="flex flex-col">
      <div className="sticky top-0 z-[4] h-[var(--tab-bar-h)] bg-background -mx-4 px-4 flex border-b">
        <button
          onClick={() => selectTab('ranking')}
          className={cn(
            'flex-1 py-2 text-sm font-medium transition-colors',
            activeTab === 'ranking'
              ? 'border-b-2 border-primary text-primary'
              : 'text-muted-foreground',
          )}
        >
          ランキング
        </button>
        <button
          onClick={() => selectTab('list')}
          className={cn(
            'flex-1 py-2 text-sm font-medium transition-colors',
            activeTab === 'list'
              ? 'border-b-2 border-primary text-primary'
              : 'text-muted-foreground',
          )}
        >
          フレンド一覧
        </button>
      </div>

      {activeTab === 'ranking' && <RankingTab />}
      {activeTab === 'list' && (
        <FriendListTab requestsOpen={requestsOpen} onRequestsOpenChange={setRequestsOpen} />
      )}
    </div>
  )
}
